import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface siteState {
  1: { pindex: number, psize:number},
  2: { pindex: number, psize:number},
}

@Injectable({
  providedIn: 'root'
})
export class ConsultationPageStateService {

    isWarningBannerDisplayed = new BehaviorSubject<boolean>(true);
    consultationsPageIndex: BehaviorSubject<number>;
    consultationsPageSize: BehaviorSubject<number>;
    searchPageIndex: BehaviorSubject<number>;
    searchPageSize: BehaviorSubject<number>;
    state: siteState = {
      1: {pindex:0, psize: 0},
      2: {pindex: 0, psize: 0},
    }

    constructor() {
      if(!sessionStorage.getItem('pref')){
        sessionStorage.setItem('pref', JSON.stringify(this.state));
      }
      let state = JSON.parse(sessionStorage.getItem('pref')) as siteState;
      this.consultationsPageIndex = new BehaviorSubject<number>(state[1].pindex);
      this.consultationsPageSize = new BehaviorSubject<number>(state[1].psize);
      this.searchPageSize = new BehaviorSubject<number>(state[2].psize);
      this.searchPageIndex = new BehaviorSubject<number>(0);
    }

    setIndex(value: number){
      let state = JSON.parse(sessionStorage.getItem('pref')) as siteState;
      state[1].pindex = value;
      sessionStorage.setItem('pref', JSON.stringify(state));
      this.consultationsPageIndex.next(value);
    }
    setSize(value: number){
      let state = JSON.parse(sessionStorage.getItem('pref')) as siteState;
      state[1].psize = value;
      sessionStorage.setItem('pref', JSON.stringify(state));
      this.consultationsPageSize.next(value);
    }
    // setSearchIndex(value: number){
    //   let state = JSON.parse(sessionStorage.getItem('pref')) as siteState;
    //   state[2].pindex = value;
    //   sessionStorage.setItem('pref', JSON.stringify(state));
    //   this.searchPageIndex.next(value);
    // }
    setSearchSize(value: number){
      let state = JSON.parse(sessionStorage.getItem('pref')) as siteState;
      state[2].psize = value;
      sessionStorage.setItem('pref', JSON.stringify(state));
      this.searchPageSize.next(value);
    }

}

